/* Shared selection rules for the product form and its runnable checks. */
var ClubCore = Object.freeze({
  variant(variants, choices) {
    return variants.find(v => v.options.every((value, index) => choices[index] === value));
  },
  bodySize(height, weight, fit, youth = false) {
    if (!Number.isFinite(height) || !Number.isFinite(weight) || !['closer','relaxed','oversized'].includes(fit)) return null;
    if (height < (youth ? 95 : 145) || height > (youth ? 170 : 205) || weight < (youth ? 14 : 40) || weight > (youth ? 65 : 145)) return null;
    const sizes = youth ? ['XS','S','M','L','XL'] : ['S','M','L','XL','2XL','3XL'];
    const mass = youth ? weight : weight * 175 / height;
    const weights = youth ? [20,27,35,45,65] : [60,75,90,108,125,150];
    const heights = youth ? [115,128,140,152,170] : [175,183,191,198,205,205];
    const wi = weights.findIndex(limit => mass <= limit);
    const hi = heights.findIndex(limit => height <= limit);
    if (wi < 0 || hi < 0) return null;
    const index = Math.max(wi, hi) + (fit === 'closer' ? -1 : fit === 'oversized' ? 1 : 0);
    return sizes[index] || null;
  },
  startingSize(width, unit, roomier, chart = [['S',18],['M',20],['L',22],['XL',24],['2XL',26],['3XL',28]]) {
    const inches = Number(width) / (unit === 'cm' ? 2.54 : 1);
    const match = chart.findIndex(row => row[1] >= inches - 1e-9);
    const index = match + Number(roomier);
    if (!Number.isFinite(inches) || !chart.length || inches < chart[0][1] - 1 || match < 0 || index < 0 || index >= chart.length) return null;
    return chart[index][0];
  }
});
